/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ElIconModule } from '../icon/icon.module';

import { ElToggleComponent } from './toggle.component';

@NgModule({
  imports: [
    CommonModule,
    ElIconModule,
  ],
  declarations: [ElToggleComponent],
  exports: [ElToggleComponent],
})
export class ElToggleModule { }
